import {useRouter} from 'next/router'
import {useCallback} from 'react'

import {OAL_SERVICE_TYPE, OptionalAgreementLayer} from '@mydata/components/OptionalAgreementLayer'
import {useQueryClient} from '@tanstack/react-query'

import {MYASSET_APIS} from '$constants/api-infos'
import auBases from '$constants/auBases'
import {INTERNAL_ROUTES} from '$constants/internal-routes'

import type {AuBase} from '$constants/auBases'

const OAL_PAGES = [
    INTERNAL_ROUTES.BANK_EMPTY,
    INTERNAL_ROUTES.BANK,
    INTERNAL_ROUTES.CARD_EMPTY,
    INTERNAL_ROUTES.CARD_APPROVAL,
    INTERNAL_ROUTES.CARD_BILL,
    INTERNAL_ROUTES.EFIN,
    INTERNAL_ROUTES.EFIN_EMPTY,
    INTERNAL_ROUTES.INSURANCE_CONTENTS,
    INTERNAL_ROUTES.INSURANCE_MY_COVERAGES,
    INTERNAL_ROUTES.INSURANCE_MY_HOME,
    INTERNAL_ROUTES.INSURANCE_MY_HOME_DIAGNOSIS,
] as const

const OAL_AU_BASE_INFO: Record<(typeof OAL_PAGES)[number], AuBase> = {
    [INTERNAL_ROUTES.BANK_EMPTY]: auBases.bank.empty,
    [INTERNAL_ROUTES.BANK]: auBases.bank.list,
    [INTERNAL_ROUTES.CARD_EMPTY]: auBases.card.empty,
    [INTERNAL_ROUTES.CARD_APPROVAL]: auBases.card.approval.list,
    [INTERNAL_ROUTES.CARD_BILL]: auBases.card.approval.list,
    [INTERNAL_ROUTES.EFIN]: auBases.efin.home,
    [INTERNAL_ROUTES.EFIN_EMPTY]: auBases.efin.empty,
    [INTERNAL_ROUTES.INSURANCE_MY_HOME]: auBases.insurance.common,
    [INTERNAL_ROUTES.INSURANCE_MY_HOME_DIAGNOSIS]: auBases.insurance.common,
    [INTERNAL_ROUTES.INSURANCE_CONTENTS]: auBases.insurance.common,
    [INTERNAL_ROUTES.INSURANCE_MY_COVERAGES]: auBases.insurance.common,
} as const

const OAL_SERVICE_TYPE_INFO = {
    [INTERNAL_ROUTES.BANK_EMPTY]: OAL_SERVICE_TYPE.BANK,
    [INTERNAL_ROUTES.BANK]: OAL_SERVICE_TYPE.BANK,
    [INTERNAL_ROUTES.CARD_EMPTY]: OAL_SERVICE_TYPE.CARD,
    [INTERNAL_ROUTES.CARD_APPROVAL]: OAL_SERVICE_TYPE.CARD,
    [INTERNAL_ROUTES.CARD_BILL]: OAL_SERVICE_TYPE.CARD,
    [INTERNAL_ROUTES.EFIN]: OAL_SERVICE_TYPE.EFIN,
    [INTERNAL_ROUTES.EFIN_EMPTY]: OAL_SERVICE_TYPE.EFIN,
    [INTERNAL_ROUTES.INSURANCE_MY_HOME]: OAL_SERVICE_TYPE.INSU,
    [INTERNAL_ROUTES.INSURANCE_MY_HOME_DIAGNOSIS]: OAL_SERVICE_TYPE.INSU,
    [INTERNAL_ROUTES.INSURANCE_CONTENTS]: OAL_SERVICE_TYPE.INSU,
    [INTERNAL_ROUTES.INSURANCE_MY_COVERAGES]: OAL_SERVICE_TYPE.INSU,
} as const

const PASS_INTERNAL_PAGES = ['/playground']

const MydataOptionalAgreementLayer = ({isSuccessLogin = true}: {isSuccessLogin?: boolean}) => {
    const {pathname} = useRouter()
    const queryClient = useQueryClient()
    const handleFinish = useCallback(() => {
        queryClient.invalidateQueries({queryKey: MYASSET_APIS.GET_MYDATA_AGREEMENT.queryKey})
    }, [queryClient])

    if (!isSuccessLogin || PASS_INTERNAL_PAGES.includes(pathname)) {
        return null
    }

    return (
        <OptionalAgreementLayer
            isShow={OAL_PAGES.includes(pathname)}
            serviceType={OAL_SERVICE_TYPE_INFO[pathname]}
            onFinish={handleFinish}
            auBaseInfo={OAL_AU_BASE_INFO[pathname]}
        />
    )
}

export default MydataOptionalAgreementLayer
